import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss']
})
export class AdminLayoutComponent implements OnInit, OnDestroy {
  pageTitle = 'Dashboard';
  private routeSub?: Subscription;

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.pageTitle = this.getDeepestTitle(this.route) || 'Dashboard';
    this.routeSub = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.pageTitle = this.getDeepestTitle(this.route) || 'Dashboard';
      });
    
    this.route.queryParams.subscribe(() => {
      setTimeout(() => {
        this.pageTitle = this.getDeepestTitle(this.route) || 'Dashboard';
      }, 10);
    });
  }

  ngOnDestroy(): void {
    this.routeSub?.unsubscribe();
  }

  private getDeepestTitle(route: ActivatedRoute): string | null {
    let current = route.firstChild;
    while (current?.firstChild) {
      current = current.firstChild;
    }
    
    const queryParams = current?.snapshot.queryParams;
    const routeData = current?.snapshot.data;
    
    if (queryParams && queryParams['mode'] === 'view' && routeData) {
      if (routeData['title'] === 'Modifier commande') {
        return 'Détails de la commande';
      }
    }
    
    return (routeData?.['title'] as string) || null;
  }
}
